import React from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

import NumberInput from "../../FormComponents/NumberInput"
import DropDown from "../../FormComponents/DropDown"
import SingleSwitch from '../../FormComponents/SingleSwitch'
import TextOption from '../../FormComponents/TextOption'
import BatteryRadio from '../FormComponents/BatteryRadio'

class AdvancedForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openAdvancedOptions: false,
            openBatteryOptions: false,
        };
    }

    render() {
        const { classes } = this.props;

        return (
            <div className="form-input-container" >
             
                <div className="form-input-container">
                    <b>Advanced Options:</b>
                </div>
                <Button
                    className={classNames(classes.marginLeft, classes.toggleAdvancedOptionsButton)}
                    onClick={() => {this.setState({openAdvancedOptions: !this.state.openAdvancedOptions})}}
                    variant='outlined'
                    color="default"
                > { this.state.openAdvancedOptions ? <span> Hide Advanced Options </span> : <span> Show Advanced Options </span> } </Button>

                <Collapse
                    in={this.state.openAdvancedOptions} timeout="auto"
                    className={classNames(classes.margin, classes.advancedOptionsContainer)}
                    >
                    <h3>General Input Options:</h3>
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Include quasi-steady calculation of continuous sources?'
                        name='staticVar'
                        value={this.props.advancedOptions.staticVar} />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min concentration of interest for this material'
                        name='conc_min'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.conc_min}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Time of release'
                        name='trel'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.trel}
                    />
                    <DropDown
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        title='Landuse'
                        name='landuse'
                        value={this.props.advancedOptions.landuse}
                        dropdownOptions={
                            [{
                                value: "CULTIVATED",
                                label: "CULTIVATED"
                            }, {
                                value: "URBAN",
                                label: "URBAN"
                            }, {
                                value: "FOREST",
                                label: "FOREST"
                            }, {
                                value: "DESERT",
                                label: "DESERT"
                            }, {
                                value: "WATER",
                                label: "WATER"
                            }, {
                                value: "GRASSLAND",
                                label: "GRASSLAND"
                            }]
                        }
                        tooltip={[<div key='stuff'></div>]}
                    />
                    <DropDown
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        title='Global precipitation'
                        name='pr_type'
                        value={this.props.advancedOptions.pr_type}
                        dropdownOptions={
                            [{
                                value: "NONE",
                                label: "NONE"
                            },{
                                value: "METFILE",
                                label: "METFILE"
                            }, {
                                value: "LGTRAIN",
                                label: "LGTRAIN"
                            }, {
                                value: "MODRAIN",
                                label: "MODRAIN"
                            }, {
                                value: "HVYRAIN",
                                label: "HVYRAIN"
                            }, {
                                value: "LGTSNOW",
                                label: "LGTSNOW"
                            }, {
                                value: "MODSNOW",
                                label: "MODSNOW"
                            }, {
                                value: "HVYSNOW",
                                label: "HVYSNOW"
                            }]
                        }
                        tooltip={[<div key='stuff'></div>]}
                    />

                    <h3>Output Options:</h3>
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Output meteorology fields in MEDOC type file?'
                        name='lout_met'
                        value={this.props.advancedOptions.lout_met} />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Time to output meteorology fields'
                        name='tout_met'
                        minMaxStep={{min:"-999999", max:"999999", step:"any" }}
                        value={this.props.advancedOptions.tout_met}
                    />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Output the 3-D fields in MEDOC type file?'
                        name='lout_3D'
                        value={this.props.advancedOptions.lout_3D} />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Output the 2-D fields in MEDOC type file?'
                        name='lout_2D'
                        value={this.props.advancedOptions.lout_2D} />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Output the wind fields in ASCII?'
                        name='lformat'
                        value={this.props.advancedOptions.lformat} />


                    <h3>Domain Options:</h3>
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Vertical extent'
                        name='zmax'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.zmax}
                        unit='m'
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Limit vertical growth of a puff'
                        name='vres'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.vres}
                        unit='m'
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Elevation at which surface dosages are computed'
                        name='z_dosage'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.z_dosage}
                        unit='m'
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Maximum puffs for the run'
                        name='maxpuff'
                        minMaxStep={{min:"0", max:"400000", step:"any" }}
                        value={this.props.advancedOptions.maxpuff}
                    />


                    <h3>Particle/Gas Options:</h3>
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Deposition velocity'
                        name='gas_deposition'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.gas_deposition}
                        unit='m/s'
                        tooltip={[<div key='stuff'>GAS only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Number of particle size groups'
                        name='nsg'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.nsg}
                        tooltip={[<div key='stuff'>PART only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Array of particle mass mean diameters (mg/m3)'
                        name='psize'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.psize}
                        tooltip={[<div key='stuff'>PART only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Bin boundaries that determine range of particle sizes within subgroup'
                        name='pbounds'
                        minMaxStep={{min:"2.5", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.pbounds}
                        tooltip={[<div key='stuff'>PART only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Number of individual material subgroups for a tracer particle release'
                        name='subgroup'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.subgroup}
                        tooltip={[<div key='stuff'>PART only</div>]}
                    />

                    <h3>Deposition Options:</h3>
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Include dense gas effects?'
                        name='dense_gas'
                        value={this.props.advancedOptions.dense_gas} />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Include deposition of each subgroup on output surface DEP file?'
                        name='group_deposition'
                        value={this.props.advancedOptions.group_deposition} />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Include total deposition on output surface DEP file?'
                        name='total_deposition'
                        value={this.props.advancedOptions.total_deposition} />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Include dose of each subgroup on output surface DOS file?'
                        name='group_dose'
                        value={this.props.advancedOptions.group_dose} />
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Include total dose on output surface DOS file?'
                        name='total_dose'
                        value={this.props.advancedOptions.total_dose} />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Daytime decay rate'
                        name='decay_amp'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.decay_amp}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Nighttime decay rate'
                        name='decay_min'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.decay_min}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Density of the Gas'
                        name='density'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.density}
                    />                    

                    <h3>Physics Options:</h3>
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Puffs subject to dynamics?'
                        name='dynamic'
                        value={this.props.advancedOptions.dynamic} />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Conditional averaging time'
                        name='t_avg'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.t_avg}
                        unit='s'
                        tooltip={[<div key='stuff'>Defining the diffusive component of turbulence.</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min puff mass'
                        name='cmin'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.cmin}
                        unit='ug/m3'
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min grid size for adaptive surface grid'
                        name='delmin'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.delmin}
                        unit='m'
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Tropospheric vertical turbulent fluctuations'
                        name='wwtrop'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.wwtrop}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Tropospheric energy dissipation rate'
                        name='epstrop'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.epstrop}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Tropospheric vertical length'
                        name='sltrop'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.sltrop}
                        unit='m'
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Mass flux for instantaneous release'
                        name='cmass'
                        minMaxStep={{min:"0", max:"9999999", step:"any" }}
                        value={this.props.advancedOptions.cmass}
                        tooltip={[<div key='stuff'>For instantaneous or continuous area release types only </div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min horizontal velocity fluctuation variance'
                        name='uu_calm'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.uu_calm}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Horizontal length scale with the horizontal velocity fluctuation variance'
                        name='sl_calm'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.sl_calm}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Number of boundary layer vertical grid levels'
                        name='nzbl'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.nzbl}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Limits horizontal growth of a puff'
                        name='mgrd'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.mgrd}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min grid size for puff resolution'
                        name='grdmin'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.grdmin}
                        unit='m'
                    />
                    <DropDown
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        title='Type of large-scale meteorological input'
                        name='ensm_type'
                        value={this.props.advancedOptions.ensm_type}
                        dropdownOptions={
                            [{
                                value: "INPUT",
                                label: "INPUT"
                            }, {
                                value: "MODEL",
                                label: "MODEL"
                            }, {
                                value: "OBS",
                                label: "OBS"
                            }, {
                                value: "OPER",
                                label: "OPER"
                            }, {
                                value: "NONE",
                                label: "NONE"
                            }]
                        }
                        tooltip={[<div key='stuff'></div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Velocity variance for large scale component of dispersion'
                        name='uu_ensm'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.uu_ensm}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Length scale for calculating meandering component of dispersion'
                        name='sl_ensm'
                        minMaxStep={{min:"0", max:"9999999", step:"any" }}
                        value={this.props.advancedOptions.sl_ensm}
                        tooltip={[<div key='stuff'>For large scale met INPUT and OBS only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Canopy height'
                        name='h_cnp'
                        minMaxStep={{min:"-1", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.h_cnp}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Surface roughness'
                        name='zruf'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.zruf}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Length scale for calculating dispersion due to wind uncertainty'
                        name='sl_haz'
                        minMaxStep={{min:"-999999", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.sl_haz}
                    />


                    <h3>Boundary Layer Options:</h3>
                    <DropDown
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        title='Boundary layer input type'
                        name='bl_type'
                        value={this.props.advancedOptions.bl_type}
                        dropdownOptions={
                            [{
                                value: "SBL",
                                label: "SBL"
                            }, {
                                value: "CALC",
                                label: "CALC"
                            }, {
                                value: "OBS",
                                label: "OBS"
                            }, {
                                value: "PROF",
                                label: "PROF"
                            }, {
                                value: "MEDOC",
                                label: "MEDOC"
                            }, {
                                value: "NONE",
                                label: "NONE"
                            }, {
                                value: "OPER",
                                label: "OPER"
                            }]
                        }
                        tooltip={[<div key='stuff'></div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min daily inversion height for calculating boundary layer'
                        name='zimin'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.zimin}
                        tooltip={[<div key='stuff'>Boundary layer type: SBL only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Max daily inversion height for calculating boundary layer'
                        name='zimax'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.zimax}
                        tooltip={[<div key='stuff'>Boundary layer type: SBL only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min daily surface heat flux for calculating boundary layer'
                        name='hconst'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.hconst}
                        tooltip={[<div key='stuff'>Boundary layer type: SBL only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Max daily surface heat flux for calculating boundary layer'
                        name='hdiur'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.hdiur}
                        tooltip={[<div key='stuff'>Boundary layer type: SBL only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Albedo'
                        name='albedo'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.albedo}
                        tooltip={[<div key='stuff'>Boundary layer type: CALC only, fraction incident light reflected by surface</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Bowen Ratio'
                        name='bowen'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.bowen}
                        tooltip={[<div key='stuff'>Boundary layer type: CALC only, ratio of sensible heat flux to latent heat flux </div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Fractional cloud cover'
                        name='cloud_cover'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.cloud_cover}
                        tooltip={[<div key='stuff'>Boundary layer type: CALC only (ignored if in obs file), Overcast: 1, Clear: 0</div>]}
                    />


                    <h3>MCWIF Options:</h3>
                    <SingleSwitch
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        label='Calculate mass consistent adjustment to winds? (MCWIF, Met type OBS only)'
                        name='lmc_ua'
                        value={this.props.advancedOptions.lmc_ua}/>
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Max value of vertical adjustment for MCWIF'
                        name='alpha_max'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.alpha_max}
                        tooltip={[<div key='stuff'>If MCWIF is True only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Min value of vertical adjustment for MCWIF'
                        name='alpha_min'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.alpha_min}
                        tooltip={[<div key='stuff'>If MCWIF is True only</div>]}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Max number of iterations for MCWIF using point relaxed method'
                        name='max_iter_ac'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.max_iter_ac}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Convergence criterion for MCWIF using point relaxation method'
                        name='ac_eps'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.ac_eps}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Max number of iterations fo MCWIF using FFT method'
                        name='max_iter'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.max_iter}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Convergence criterion for MCWIF using FFT method'
                        name='p_eps'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.p_eps}
                    />
                    <TextOption
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        title='Vertical grid levels'
                        name='zb'
                        maxLength='250'
                        placeholder="50,150,385,675,845,1032,1467,1719,1996,2300,2634,3592,4503,6227,7444,9000,11000"
                        width='650px'
                        value={this.props.advancedOptions.zb}
                        tooltip={[<div key='zb'>Comma separated list of vertical grid levels in meters.</div>]}
                    />
               





               </Collapse>

               <div className="form-input-container">
                    <b>Battery Fire Options:<FaInfoCircle data-tip data-for='batteryfire'/> </b>

                    <ReactTooltip id='batteryfire' place="right" type="light" effect="solid">
                        The below options along with the site location and source information must be updated if the Run Option is "Battery Fire Simulation" 
                    </ReactTooltip>
                </div>
                <Button
                    className={classNames(classes.marginLeft, classes.toggleAdvancedOptionsButton)}
                    onClick={() => {this.setState({openBatteryOptions: !this.state.openBatteryOptions})}}
                    variant='outlined'
                    color="default"
                > { this.state.openBatteryOptions ? <span> Hide Battery Fire Options </span> : <span> Show Battery Fire Options </span> } </Button>

                <Collapse
                    in={this.state.openBatteryOptions} timeout="auto"
                    className={classNames(classes.margin, classes.batteryOptionsContainer)}
                >
                    <BatteryRadio
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        batteryoption={this.props.advancedOptions.batteryoption}
                    />                     
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Density of the Gas (used in thermal runaway simulation)'
                        name='density'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.density}
                    />
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Percent of HF in the air'
                        name='percent_HF'
                        minMaxStep={{min:"0", max:"100", step:"any" }}
                        value={this.props.advancedOptions.percent_HF}
                        unit='%'
                    /> 
                    <NumberInput
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        instructions='Gas Deposition velocity'
                        name='gas_deposition'
                        minMaxStep={{min:"0", max:"99999", step:"any" }}
                        value={this.props.advancedOptions.gas_deposition}
                        unit='m/s'
                        tooltip={[<div key='stuff'>~0.03 for HF and HCl</div>]}
                    />                                                              
                    <DropDown
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        title='Landuse'
                        name='landuse'
                        value={this.props.advancedOptions.landuse}
                        dropdownOptions={
                            [{
                                value: "CULTIVATED",
                                label: "CULTIVATED"
                            }, {
                                value: "URBAN",
                                label: "URBAN"
                            }, {
                                value: "FOREST",
                                label: "FOREST"
                            }, {
                                value: "DESERT",
                                label: "DESERT"
                            }, {
                                value: "WATER",
                                label: "WATER"
                            }, {
                                value: "GRASSLAND",
                                label: "GRASSLAND"
                            }]
                        }
                        tooltip={[<div key='stuff'></div>]}
                    />
                 
                </Collapse>                
            </div>

        );
    }
}
export default AdvancedForm
